import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Components from 'components';
import Plugins from 'plugins';
import { CountUp } from 'countup.js';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.data('contCarousel', count => ({
    open: false,
    active: 0,
    count,
    triggerId: '',
    bodyWasLocked: false,
    openLightbox(index, triggerId) {
        this.active = index;
        this.triggerId = triggerId;
        this.bodyWasLocked = document.body.classList.contains('overflow-hidden');
        document.body.classList.add('overflow-hidden');
        this.open = true;
        this.$nextTick(() => this.$refs.closeButton.focus());
    },
    closeLightbox() {
        this.open = false;
        if (!this.bodyWasLocked) {
            document.body.classList.remove('overflow-hidden');
        }
        this.$nextTick(() => {
            const trigger = document.getElementById(this.triggerId);
            if (trigger) {
                trigger.focus();
            }
        });
    },
    previous() {
        this.active = (this.active - 1 + this.count) % this.count;
    },
    next() {
        this.active = (this.active + 1) % this.count;
    },
}));

Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    Components.init();
    Plugins.init();

    if($('.countup').length) {
        $('.countup').each(function(i) {
            let count = new CountUp($(this).attr('id'), $(this).attr('data-count'), {
                enableScrollSpy: true,
            });
        });
    }
});
